import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B22({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XY13.error_id: {
            return (
                <>
                    <ResultText>
                        Schematic Channel DS Reach Length could not be calculated accurately for the following cross sections because the cutline of the DS cross section does not intersect the stream centerline.
                        <EmptyLine />
                    </ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row?.data?.map(r => r.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.XY11.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences at Channel DS Reach Lengths between Assigned (at Cross Section Data) and Calculated using the Schematic XY values. The cross sections with a difference more than {settings?.thresholds?.dsrl_tol} ft are listed in the table below.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}></ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center'}} colSpan={3}>Channel DS Reach Length (ft)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    Assigned
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    Calculated
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    Difference
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>

                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.channel}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.length}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.diff}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}